const toArrayImageFromImageRegex = (imgRegex) => {
  return imgRegex.split(" ");
};

export default toArrayImageFromImageRegex;
